import React from 'react'

import { Candidate } from '../../types'

type ApplicationContextValue = {
  user?: Candidate
  setUser?: React.Dispatch<React.SetStateAction<Candidate | undefined>>
}

export const ApplicationContext = React.createContext<ApplicationContextValue>(undefined!)
